import { QueryStringParams } from '../constants/query-string-params';
import { updateQueryStringValue } from '../utils/string-helpers/search-query-string-helper';
import { ReadonlyURLSearchParams } from 'next/navigation';

export function useQuerySortOrder(searchParams: ReadonlyURLSearchParams) {
  const getSortOrder = (): string => searchParams.get[QueryStringParams.SortOrder]?.toString();

  let searchQueryParams = {};
  for (const [key, value] of searchParams.entries()) {
    searchQueryParams[key] = value;
  }

  const setSortOrder = (sortOrder: string) => {
    updateQueryStringValue(searchQueryParams, QueryStringParams.SortOrder, sortOrder, true);
  };

  return {
    getSortOrder,
    setSortOrder,
  };
}
